import api from "@/lib/api";

export async function fetchSponsors(params = {}) {
  const { data } = await api.get("/sponsors", { params });
  return data;
}
export async function fetchSponsorsByStory(storyId) {
  const { data } = await api.get(`/sponsors/by-story/${storyId}`);
  return data;
}
export async function adminListSponsors(params = {}) {
  const { data } = await api.get("/admin/sponsors", { params });
  return data;
}
export async function adminCreateSponsor(payload) {
  const { data } = await api.post("/admin/sponsors", payload);
  return data;
}
export async function adminUpdateSponsor(id, payload) {
  const { data } = await api.put(`/admin/sponsors/${id}`, payload);
  return data;
}
export async function adminArchiveSponsor(id) {
  const { data } = await api.patch(`/admin/sponsors/${id}/archive`);
  return data;
}
export async function adminDeleteSponsor(id) {
  await api.delete(`/admin/sponsors/${id}`);
}
